<div class="form-section">
  <div class="section-header">
    <div class="section-label">
      <span class="section-num">04.A</span>
      <span class="section-title">SKU applicability</span>
    </div>
    <span class="section-hint">{{ allowedSkuCount }} allowed · {{ restrictedSkuCount }} restricted · 0 inherited</span>
  </div>

  <div class="sku-stats-row">
    <div class="sku-stat-card sku-stat-card--allowed">
      <span class="sku-stat-label">ALLOWED</span>
      <span class="sku-stat-value">{{ allowedSkuCount }}</span>
    </div>
    <div class="sku-stat-card sku-stat-card--restricted">
      <span class="sku-stat-label">Restricted</span>
      <span class="sku-stat-value">{{ restrictedSkuCount }}</span>
    </div>
    <div class="sku-stat-card sku-stat-card--inherited">
      <span class="sku-stat-label">Inherited categories</span>
      <span class="sku-stat-value">0</span>
    </div>
  </div>
</div>

<div class="section-divider"></div>

<div class="form-section">
  <div class="section-header">
    <div class="section-label">
      <span class="section-num">04.B</span>
      <span class="section-title">Active SKU rules</span>
    </div>
    <span class="section-hint">{{ skuRules.length }} of 50 shown</span>
  </div>

  <div class="sku-rules-list">
    @for (rule of skuRules; track rule.id) {
    <div class="sku-rule-row">
      <span class="sku-type-badge" [class]="'sku-type-badge--' + rule.type.toLowerCase()">
        {{ rule.type }}
      </span>
      <span class="sku-code-badge">{{ rule.code }}</span>
      <span class="sku-rule-label">{{ rule.label }}</span>
      @if (rule.meta) {
        <span class="sku-rule-meta">{{ rule.meta }}</span>
      }
    </div>
    }
  </div>
</div>

<div class="section-divider"></div>
